export default __webpack_public_path__ + "static/iconfinder_20_3319624-bc8493ae4488fce40f83f3a4dd291ac9.png";